import { LogData } from '@1js/ai-hub-telemetry';
import { getAiHubLogger } from './AiHubTelemetryService';
export var logModuleLoadDuration = function (promise, componentName) {
    var logger = getAiHubLogger();
    var activity = logger === null || logger === void 0 ? void 0 : logger.startActivity('Module.Activity.Load');
    activity === null || activity === void 0 ? void 0 : activity.addLogData([new LogData('ModuleName', componentName)]);
    return promise
        .then(function (module) {
        activity === null || activity === void 0 ? void 0 : activity.endSuccessful();
        return module;
    })
        .catch(function (error) {
        activity === null || activity === void 0 ? void 0 : activity.addErrorDataToActivity(error);
        activity === null || activity === void 0 ? void 0 : activity.endFailure();
        throw error;
    });
};
//# sourceMappingURL=logModuleLoadDuration.js.map